import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box } from "@mui/material";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

import {
  vendorTypeOptions,
  accountStatusOptions,
  singleSearchOptions,
} from "./helper";
import SingleSearchRadioGroup from "./SingleSearchRadioGroup";
import { useVendorMgmtContext } from "./context";

const SearchForVendors = () => {
  const history = useHistory();
  const { globalFilter, setGlobalFilter } = useVendorMgmtContext();
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns,
  );

  const [buOptions, setBuOptions] = useState([]);

  useEffect(() => {
    if (masterDropdowns?.businessArea?.length) {
      const options = masterDropdowns.businessArea.map((item) => ({
        label: item.label,
        value: item.businessAreaId,
      }));
      setBuOptions(options);
    }
  }, [masterDropdowns?.businessArea]);

  const handleSearchModeChange = (event) => {
    setGlobalFilter((prev) => ({
      ...prev,
      searchMode: event.target.value,
      // Reset other filters when changing search mode
      singleSearchType: "vendorSapCode",
      singleSearchValue: "",
      vendorType: [],
      bu: [],
      accountStatus: [],
    }));
  };

  const handleSingleSearchTypeChange = (event) => {
    setGlobalFilter((prev) => ({
      ...prev,
      singleSearchType: event.target.value,
      singleSearchValue: "", // Clear input when search type changes
    }));
  };

  const handleSingleSearchValueChange = (event) => {
    setGlobalFilter((prev) => ({
      ...prev,
      singleSearchValue: event.target.value,
    }));
  };

  const formHandler = (key, value) => {
    setGlobalFilter((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearch = async () => {
    // Pass filters via query params for hash router compatibility
    const query = new URLSearchParams();
    query.set("filters", JSON.stringify(globalFilter));
    history.push(`/admin/vendorsList?${query.toString()}`);
  };

  return (
    <>
      <Box sx={{ marginBottom: "20px" }}>
        <AButton
          variant={
            globalFilter.searchMode === "single" ? "primary_filled" : "outline"
          }
          onClick={() =>
            handleSearchModeChange({ target: { value: "single" } })
          }
          sx={{ marginRight: "10px" }}
          size="xs"
          className="no-ml-btn"
        >
          Single
        </AButton>
        <AButton
          variant={
            globalFilter.searchMode === "bulk" ? "primary_filled" : "outline"
          }
          onClick={() => handleSearchModeChange({ target: { value: "bulk" } })}
          size="xs"
        >
          Bulk
        </AButton>
      </Box>
      {globalFilter.searchMode === "single" && (
        <Box>
          <SingleSearchRadioGroup
            selectedValue={globalFilter.singleSearchType}
            onChange={(value) =>
              handleSingleSearchTypeChange({ target: { value } })
            }
            options={singleSearchOptions}
          />
          <Box sx={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <AInput
              placeholder={`Search by ${
                singleSearchOptions.find(
                  (option) => option.value === globalFilter.singleSearchType,
                )?.label
              }`}
              style={{ height: "45px", width: "500px", flexGrow: 1 }}
              value={globalFilter.singleSearchValue}
              handler={(value) =>
                handleSingleSearchValueChange({ target: { value } })
              }
              rightSearchIcon={true}
              searchIconClickHandler={handleSearch}
            />
            <AButton
              variant="primary_filled"
              onClick={handleSearch}
              disabled={!globalFilter.singleSearchValue}
            >
              Search vendor
            </AButton>
          </Box>
        </Box>
      )}

      {globalFilter.searchMode === "bulk" && (
        <Box
          sx={{
            width: "70%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr) auto", // Three columns for dropdowns, auto for button
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          <AAutoComplete
            label="Vendor Type*"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={vendorTypeOptions}
            currentValue={globalFilter.vendorType}
            handleChange={(value) => formHandler("vendorType", value)}
            height="45px"
          />
          <AAutoComplete
            label="BU"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={buOptions}
            currentValue={globalFilter.bu}
            handleChange={(value) => formHandler("bu", value)}
            height="45px"
          />
          <AAutoComplete
            label="Account Status"
            placeholder="Select"
            isMulti={true}
            isShowCount
            items={accountStatusOptions}
            currentValue={globalFilter.accountStatus}
            handleChange={(value) => formHandler("accountStatus", value)}
            height="45px"
          />
          <AButton
            variant="primary_filled"
            onClick={handleSearch}
            disabled={globalFilter.vendorType.length === 0}
            className="mt-auto"
          >
            Search vendors
          </AButton>
        </Box>
      )}
    </>
  );
};

export default SearchForVendors;
